import { coreBlocks } from "./coreBlocks";
import { jltBlocks } from "./jltBlocks";
import { masterBlocks } from "./masterBlocks";

const gutenbergBlocks = {
  ...coreBlocks,
  ...jltBlocks,
  ...masterBlocks,
};

export const BlockRenderer = ({ blocks }) => {
  return blocks?.map((block) => {
    const renderBlock = gutenbergBlocks?.[block?.name];

    if (typeof renderBlock === "function") {
      return renderBlock(block);
    } else {
      console.warn(`No renderer for block: ${block?.name}`);
      return null; // render nothing for unknown block
    }
  });
};
